<template>
    <v-card flat style="border-top: 1px solid lightgray">
        <v-overlay :value="loadingShopList">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <div class="pa-5">
            <v-row no-gutters>
                <v-col class="col-item">
                    <date-picker
                        v-if="hasPermissionForAction(PermissionsConstants.SEARCH)"
                        v-model="datepickerStartDate"
                        :max-date="dateToday"
                        :min-date="minDate"
                        :popover="{ placement: 'bottom', visibility: 'click' }"
                    >
                        <template v-slot="{ inputValue, inputEvents }">
                            <v-text-field
                                id="start_date"
                                v-on="inputEvents"
                                :value="inputValue"
                                append-icon="fas fa-calendar"
                                :label="'Turnover start date' | t"
                                hide-details
                                dense
                                outlined
                            />
                        </template>
                    </date-picker>
                </v-col>
                <v-col class="col-item ml-4">
                    <date-picker
                        v-if="hasPermissionForAction(PermissionsConstants.SEARCH)"
                        v-model="datepickerEndDate"
                        :max-date="dateToday"
                        :min-date="minDate"
                        :popover="{ placement: 'bottom', visibility: 'click' }"
                    >
                        <template v-slot="{ inputValue, inputEvents }">
                            <v-text-field
                                id="end_date"
                                v-on="inputEvents"
                                append-icon="fas fa-calendar"
                                :label="'Turnover end date' | t"
                                :value="inputValue"
                                hide-details
                                dense
                                outlined
                            />
                        </template>
                    </date-picker>
                </v-col>
            </v-row>
        </div>
        <v-data-table
            class="product-table"
            dense
            :items="shops"
            :items-per-page="50"
            :footer-props="footerProps"
            :headers="shopsAdminTableHeaders"
            :options.sync="options"
            :server-items-length="totalShopsCount"
        >
            <template v-for="h in shopsAdminTableHeaders" v-slot:[`header.${h.value}`]="{ header }">
                <span :class="'text-' + header.align">{{ header.text ? t(header.text) : "-" }}</span>
            </template>
            <template v-slot:item="{ item }">
                <tr
                    :key="'shop_' + item.id"
                    @click="handleTableRowClick(item)"
                    :class="{ activeTableRow: activeShop && parseInt(item.id) === parseInt(activeShop.id) }"
                >
                    <td
                        v-for="(row, index) in shopsAdminTableHeaders"
                        :class="{
                            lastColumn:
                                index === shopsAdminTableHeaders.length - 1 && shopsAdminTableHeaders.length > 2,
                            penultimateColumn:
                                index === shopsAdminTableHeaders.length - 2 && shopsAdminTableHeaders.length > 2
                        }"
                    >
                        <span v-if="row.value === 'turnover'">{{
                            item[row.value] !== 0 ? `${rn(item[row.value], 2)}€` : "-"
                        }}</span>
                        <span v-else>{{ item[row.value] ? item[row.value] : "-" }}</span>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import Store from "../../store";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "shops-admin-list",
    components: {
        DatePicker
    },
    data() {
        return {
            footerProps: { "items-per-page-options": [25, 50, 100, 500, 1000] },
            options: this.tableOptions,
            dateToday: new Date(),
            minDate: new Date(2020, 0, 1),
            datepickerStartDate: new Date(2020, 0, 1),
            datepickerEndDate: new Date()
        };
    },
    mounted() {
        if (this.drawerOpen) {
            document.documentElement.style.overflow = "hidden";
        }
    },
    watch: {
        options(val) {
            Store.commit("ShopsAdminStore/setTableOptions", val);
        },
        drawerOpen() {
            if (this.drawerOpen) {
                document.documentElement.style.overflow = "hidden";
            } else {
                document.documentElement.style.overflow = "auto";
            }
        },
        datepickerStartDate: function(value) {
            Store.commit("ShopsAdminStore/setStartDate", value);
        },
        datepickerEndDate: function(value) {
            Store.commit("ShopsAdminStore/setEndDate", value);
        }
    },
    computed: {
        ...mapState("ShopsAdminStore", [
            "shops",
            "loadingShopList",
            "activeShop",
            "exportMode",
            "exportProducts",
            "tableOptions",
            "totalShopsCount",
            "drawerOpen",
            "shopsAdminTableHeaders"
        ]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        handleTableRowClick(shop) {
            if (!this.hasPermissionForAction(PermissionsConstants.SHOP, PermissionsConstants.VIEW)) {
                return;
            }
            if (this.$route.name !== "shops-admin-view") {
                this.$router.push({ name: "shops-admin-view", params: { shopId: shop.id } });

                return;
            }
            if (this.$route.name === "shops-admin-view" && parseInt(shop.id) !== parseInt(this.$route.params.shopId)) {
                this.$router.push({ name: "shops-admin-view", params: { shopId: shop.id } });
                Store.dispatch("ShopsAdminStore/getShopData", shop.id);
            }
        }
    }
};
</script>

<style scoped>
.lastColumn {
    text-align: center;
}

.penultimateColumn {
    text-align: end;
}

.activeTableRow {
    background-color: #f41823;
    color: #fff;
}

.activeTableRow:hover {
    background-color: #e11520 !important;
    color: #fff !important;
}

.dot {
    margin-top: 4px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}

.v-data-table-header {
    background-color: #f0f0f0;
}

.preventscroll {
    overflow-y: scroll;
    width: 100%;
}

::v-deep .v-data-table-header th {
    white-space: nowrap;
}

td {
    height: 25px !important;
}
</style>
